import { PageListCachedDataSource } from './BaseDataSources';
import { ITradingProduct } from '../Interfaces';

export class TradingProductSource extends PageListCachedDataSource<ITradingProduct> {
  public constructor() {
    super('/datasource/tradingproducts');
  }
}